/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


import { MDLocaleBase } from '../../manja/locale-base.js';


const MDLocale_de_DE = function(window) {

	const decimal_point_char = ',';
	const duration_units = [
		[ '1 Jahr',    ' Jahre',   31536000 ],
		[ '1 Monat',   ' Monate',   2592000 ],
		[ '1 Woche',   ' Wochen',    604800 ],
		[ '1 Tag',     ' Tage',       86400 ],
		[ '1 h',       ' h',           3600 ],
		[ '1 min',     ' min',           60 ],
		[ '1 s',       ' s',              1 ],
	];

	const m_monthNames = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];


	function fmt_number_input( n ) {
		return n.toString().replace( /\./g, decimal_point_char );
	}
	function xtr_number_input( n ) {
		return n.toString().replace( /\./g, '' ).replace( /,/g, '.' );
	}

	function fmt_datetime( d ) {
		var sd = fmt_date(d),
			st = fmt_time(d);
		if( st==='' || st==='00:00' ) return sd;
		return sd + ', ' + st;// + ' Uhr';
	}
	function fmt_datetime_detailed( d ) {
		var sd = fmt_date(d),
			st = fmt_time_detailed(d);
		return st==='' ? sd : (sd+', '+st);
	}

	function fmt_date( d ) {
		if( d===null || d.length===0 ) return '';
		return d.substr(8,2) + '.' + d.substr(5,2) + '.' + d.substr(0,4);
	}
	function fmt_date_ym( d ) {
		if( d===null || d.length===0 ) return '';
		return m_monthNames[parseInt(d.substr(5,2),10)-1] + ' ' + d.substr(0,4);
	}

	function fmt_time( d ) {
		if( d===null || d.length===0 ) return '';
		var offs = d.length >= 10 ? 11 : 0, // datetime or time-only
			s = d.substr(offs,2) + ':' + d.substr(offs+3,2),
			sec = d.substr(offs+6,2)
			;
		if( sec === '' || sec === '00' ) return s===':' ? '' : s;
		return s + ':' + sec;
	}
	function fmt_time_detailed( d ) {
		if( d.length < 19 ) return '';
		return d.substr(11,2) + ':' + d.substr(11+3,2) + ':' + d.substr(11+6,2);
	}

	function xtr_datetime( sd, st ) {
		var d = xtr_date(sd);
		if( d !== '' ) {
			var t = xtr_time(st);
			if( t === '' ) t = '00:00:00'; // set to midnight
			d += ' ' + t;
		}
		return d;
	}
	function xtr_date( s ) {
		if( !s.match(/^\d\d\.\d\d\.\d\d\d\d$/) ) return '';
		return s.substr(6,4) + '-' + s.substr(3,2) + '-' + s.substr(0,2);
	}
	function xtr_time( s ) {
		if( s.match(/^\d\d:\d\d:\d\d$/) ) return s;
		else if( s.match(/^\d\d:\d\d$/) ) return s+':00';
		else if( s.match(/^\d\d$/) ) return s+':00:00';
		return '';
	}

	var localized_string_compare = function( a, b ) {
		return a.localeCompare(b,'de-DE',{ignorePunctuation:true});
	};

	try {
		'foo'.localeCompare('bar','de-DE',{ignorePunctuation:true});
	} catch( err ) {
		localized_string_compare = function( a, b ) {
			return a.localeCompare(b);
		};
	}


	return Object.assign( {}, MDLocaleBase, {

		fmt_number_input,
		xtr_number_input,
		fmt_datetime,
		fmt_datetime_detailed,
		fmt_date,
		fmt_date_ym,
		fmt_time,
		fmt_time_detailed,
		xtr_datetime,
		xtr_date,
		xtr_time,
		localized_string_compare,

		decimal_point_char,
		duration_units,

		get_locale: function() {
			return 'de_DE';
		},

		initWithJQuery: function( $ ) {
			/* German initialisation for the jQuery UI date picker plugin. */
			if( $ && $.datepicker ) {
				/* Written by Milian Wolff (mail@milianw.de). */
				$.datepicker.regional['de'] = {
					closeText: 'schließen',
					prevText: '&#x3c;zurück',
					nextText: 'Vor&#x3e;',
					currentText: 'heute',
					monthNames: m_monthNames,
					monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
					dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
					dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
					dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
					weekHeader: 'Wo',
					dateFormat: 'dd.mm.yy',
					firstDay: 1,
					isRTL: false,
					showMonthAfterYear: false,
					yearSuffix: ''};
				$.datepicker.setDefaults($.datepicker.regional['de']);
			}
			// select2 i18n
			if( $ && $.fn.select2 ) {
				$.fn.select2.defaults.set('language',{
					errorLoading:function() {
						return "Ergebnisse konnten nicht geladen werden.";
					},
					inputTooLong:function(e) {
						var t=e.input.length-e.maximum; return "Bitte "+t+" Zeichen weniger eingeben";
					},
					inputTooShort:function(e) {
						var t=e.minimum-e.input.length; return "Bitte "+t+" Zeichen mehr eingeben";
					},
					loadingMore:function() {
						return "Lade mehr Ergebnisse…";
					},
					maximumSelected:function(e) {
						var t="Sie können nur "+e.maximum+" Eintr"; return e.maximum===1?t+="ag":t+="äge",t+=" auswählen",t;
					},
					noResults:function() {
						return "Keine Übereinstimmungen gefunden";
					},
					searching:function(e) {
						window._mj_cur_select2_query=e; return "Suche…";
					},
				});
			}
		}
	} );
}(window); // namespace MDLocale_de_DE

MDLocaleBase.init_with_impl(MDLocale_de_DE);

// eslint-disable-next-line import/no-unused-modules
export default MDLocale_de_DE;
